import { render, staticRenderFns } from "./TaskConfigList.vue?vue&type=template&id=86981232&scoped=true"
import script from "./TaskConfigList.vue?vue&type=script&lang=js"
export * from "./TaskConfigList.vue?vue&type=script&lang=js"
import style0 from "./TaskConfigList.vue?vue&type=style&index=0&id=86981232&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86981232",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86981232')) {
      api.createRecord('86981232', component.options)
    } else {
      api.reload('86981232', component.options)
    }
    module.hot.accept("./TaskConfigList.vue?vue&type=template&id=86981232&scoped=true", function () {
      api.rerender('86981232', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-task/TaskConfigList.vue"
export default component.exports